import React from 'react';
import { Stack } from '@mui/material';
import { IconLibrary, PermissionIconButton } from '@product-framework/index';
import {
  formatUSPhoneNumber,
  getSMSSubscriptionAttributes,
  InsightChipWithToolTip,
} from '@product-framework/components/FormFields/PhoneNumber';

function phoneNumber(row, _props, additional) {
  const { saPhoneNumber, insightPurchased } = additional || {};
  const formattedPhoneNumber = formatUSPhoneNumber(row?.phoneNumber);
  const status = row?.smsSubscriptionStatus;

  if (!insightPurchased || !status) {
    return formattedPhoneNumber;
  }

  return (
    <Stack direction="row" alignItems="center" flexWrap="nowrap">
      {formattedPhoneNumber}
      <InsightChipWithToolTip
        sx={{ ml: 1 }}
        status={getSMSSubscriptionAttributes(status, saPhoneNumber)}
      />
    </Stack>
  );
}

function description(row) {
  return row?.description;
}

function isVoiceEnabled(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isVoiceEnabled === true
    ? formatMessage({
        id: 'INSIGHT_CONTACT_VOICE_ENABLED',
        defaultMessage: 'Enabled',
      })
    : formatMessage({
        id: 'INSIGHT_CONTACT_VOICE_DISABLED',
        defaultMessage: 'Disabled',
      });
}

function isVoiceDefault(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isVoiceDefault === true
    ? formatMessage({
        id: 'INSIGHT_CONTACT_VOICE_DEFAULT',
        defaultMessage: 'Yes',
      })
    : formatMessage({
        id: 'INSIGHT_CONTACT_VOICE_NOT_DEFAULT',
        defaultMessage: 'No',
      });
}

function isTextEnabled(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isTextEnabled === true
    ? formatMessage({
        id: 'INSIGHT_CONTACT_TEXT_ENABLED',
        defaultMessage: 'Opted-in',
      })
    : formatMessage({
        id: 'INSIGHT_CONTACT_TEXT_DISABLED',
        defaultMessage: 'Opted-out',
      });
}

function isTextDefault(row, _props, additional) {
  const { formatMessage } = additional || {};

  return row?.isTextDefault === true
    ? formatMessage({
        id: 'INSIGHT_CONTACT_TEXT_DEFAULT',
        defaultMessage: 'Yes',
      })
    : formatMessage({
        id: 'INSIGHT_CONTACT_TEXT_NOT_DEFAULT',
        defaultMessage: 'No',
      });
}

function actions(row, _props, additional) {
  const { onEdit, onDelete } = additional || {};

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <PermissionIconButton
        permissionName="CAN_UPDATE_SP_INSIGHT_CONTACTS"
        size="small"
        sx={{ p: 0.25, minWidth: 28 }}
        onClick={() => onEdit?.(row)}>
        <IconLibrary.FormChanged fontSize="small" />
      </PermissionIconButton>
      <PermissionIconButton
        permissionName="CAN_UPDATE_SP_INSIGHT_CONTACTS"
        size="small"
        color="error"
        sx={{ p: 0.25, minWidth: 28 }}
        onClick={() => onDelete?.(row)}>
        <IconLibrary.Delete fontSize="small" />
      </PermissionIconButton>
    </Stack>
  );
}

export {
  phoneNumber,
  description,
  isVoiceEnabled,
  isVoiceDefault,
  isTextEnabled,
  isTextDefault,
  actions,
};
